module.exports = __webpack_public_path__ + "static/media/carousel-placeholder-02.3c3c76c3.jpg";